import request from '../utils/request';

export const fetchBoardMessagesAPI = async (eventId: string) => {
    const boardMessages = await request.get(`/boards/${eventId}`);
    return boardMessages.data;
};

export const createBoardMessageAPI = async (
    eventId: string,
    message: string
) => {
    const record = await request.post(`/boards/${eventId}`, {
        eventId,
        message,
    });
    return record.data;
};
